// NOTE: Dependencies: jQuery

(function ($) {
  $.fn.lmNowPlaying = function(options) {
    // check is dom element is defined
    if (!this.length) {
      return false;
    }

    // Default settings are set here.
    var settings = $.extend({
      placeholder: '.feature-spacer',
      $placeholder: $('.feature-spacer'),
      standardClass: 'feature-wrapper--now-playing',
      activeClass: 'feature-wrapper--now-playing-active',
      changingClass: 'video-player--changing',
      pausedClass: 'video-player--paused',
      headerWrapper: '.mobile-wrapper',
      videoContent: '.video-player__content',
      $nextUp: $('#playing').parent().next().find('a')[0],
      $videoPlayer: $('.video-player'),
      adPlaying: ".vjs-ad-playing",
      ended: ".vjs-ended"
    }, options);

    // These are all the methods available for the plugin.
    var methods = {};

    var  _currentVideoId = $('[data-current-bcvid]:first').data('current-bcvid'),
      $playingItem = $('[data-bcvid="'+ _currentVideoId +'"]').parent(),
      $wrapper = $(settings.wrapper),
      featuredMarkUp = '';

    // NOTE: modified next up to work with new drupal template
    settings.$nextUp = $playingItem.next().find('a')[0];

    // Variables
    var timeOut = false,
    myPlayer = false,
    scrollTimeout = false,
    isPlaying = false,
    recordedStatus = false;

    // $container needs to be different on webkit.
    if(navigator.userAgent.indexOf('AppleWebKit') != -1){
      var $container = $('body');
    } else {
      var $container = $('html');
    }

    methods.setCurrentSettings = function($context) {
      var currentSettings = $context.data();

      if (!$.isEmptyObject(currentSettings)) {
        $context.data($.extend({}, settings, currentSettings));
      } else {
        $context.data(settings);
      }

      // Initialize item.
      $context.data('initialized', true);
    }

    // Function runs on window resize.
    methods.scroll = function ($context) {
      // Get the current position of the bottom of the panel.
      var offset = settings.$placeholder.offset(),
      bottomPos = offset.top + settings.$placeholder.height();


      if($(".vjs-ad-playing").length > 0) {
        settings.$videoPlayer.removeClass(settings.pausedClass);
      }

      // If the main feature is in view.
      if ($context.hasClass(settings.activeClass) && $container.scrollTop() < bottomPos){
        // Record playing status before the player is detached (detach pauses the player and causes a real pickle)
        if (isPlaying == true) {
          recordedStatus = true;
        } else {
          recordedStatus = false;
        }

        // Remove the classes and move into position.
        $context.removeClass(settings.activeClass).removeClass(settings.standardClass)

        setTimeout(function(){
          // Remove hard coded height.
          settings.$placeholder.css({"height": "auto"});
          // Player video after the move and hide/show the controls.
           if (myPlayer ) {
             myPlayer.controls(true);
           }
        }, 250);

      // If the main feature is not in view.
      } else if (!$context.hasClass(settings.activeClass) && $container.scrollTop() >= bottomPos) {

        // Hard code the placeholders height.
        settings.$placeholder.height(settings.$placeholder.height());

        // Record playing status before the player is detached (detach pauses the player and causes a real pickle)
        if (isPlaying == true) {
          recordedStatus = true;
        } else {
          recordedStatus = false;
        }

        // Move the video into the header.
        $context.addClass(settings.standardClass);
        // .detach().appendTo(settings.headerWrapper)
        setTimeout(function(){
          // Add class to start the animation.
          $context.addClass(settings.activeClass);
          // Player video after the move and hide/show the controls.
          if(myPlayer) {
            myPlayer.controls(false);
          }
        }, 10);
      }
    }

    // On load function
    methods.initContext = function($context) {
      methods.setCurrentSettings($context);

      $(window).on('scroll', function () {
        methods.scroll($context);
      });

      $( document ).ready(function() {

        myPlayer = videojs.getPlayer('main-video');

        myPlayer.on('ended', function(){
          console.log ('Player ended..........');
          // Start the CSS countdown timer.
          settings.$videoPlayer.addClass(settings.changingClass);

            // After 3 seconds, click the next video link.
            timeOut = setTimeout(function(){
                  methods.nextVideo($context);
                }, 3000);

          settings.$videoPlayer.removeClass(settings.pausedClass);

        });


        videojs.getPlayer('main-video').ready(function(){
          console.log( "Player ready!...................." );
          // Autoplay.
          //myPlayer = this;
          // Turn off autoplay per Greg.
          // myPlayer.play();

          if($(settings.adPlaying).length > 0) {
             settings.$videoPlayer.removeClass(settings.pausedClass);
          }

           // Get the current position of the bottom of the panel.
           var offset = settings.$placeholder.offset();
           var bottomPos = offset.top + settings.$placeholder.height();

          // If the main feature is in view.
          if ($container.scrollTop() >= bottomPos) {
            myPlayer.controls(false);
          }
        });

        myPlayer.on('timeupdate', function() {
          console.log ('Player timeup..........');
          // If the countdown to the next video is playing and the user presses play again, the countdown stops.
          if(timeOut) {
            clearTimeout(timeOut);
            timeOut = false;
            settings.$videoPlayer.removeClass(settings.changingClass);
          }
        });

        myPlayer.on('play', function() {
          console.log ('Player play..........');
          settings.$videoPlayer.removeClass(settings.pausedClass);
          isPlaying = true;
        });

        myPlayer.on('pause', function() {
          console.log ('Player pause..........');
          isPlaying = false;
          if ($context.closest('.panel-dark').length > 0 && $(settings.ended).length < 1) {
            settings.$videoPlayer.addClass(settings.pausedClass);
          }
        });
      });

      $(document).off('click.lmNowPlaying').on('click.lmNowPlaying', '.feature-wrapper--now-playing-active .video-player', function() {
        if(myPlayer) {
          if ($(this).hasClass(settings.pausedClass) && $(settings.ended).length < 1) {
            myPlayer.play();
          } else {
            myPlayer.pause();
          }
        }
        $(this).toggleClass(settings.pausedClass);
      });
    }

    methods.nextVideo = function($context){

      if($("#featuredVideos").children().length > 0){
        settings.$nextUp?.click();
      } else {
        // Click the first category tab
        $('.tab-nav__item').find('a')[0].click();
      }
    };


    // Filter each function.
    methods.filterEach = function() {
      return !$(this).data("initialized");
    }

    // Methods to run inside loop.
    return this.filter(methods.filterEach).each(function() {
      var $this = $(this);

      // NOTE: Method you'd like initialized on a per context basis.
      methods.initContext($this);
    });
  };
}(jQuery));